import { db } from '../../firebase'
import moment from 'moment'

const clients = db.collection('clients')

export default {
  index() {
    const data = []
    clients.get().then(docs => {
      docs.forEach((doc) => {
        data.push({
          ...doc.data(),
          id: doc.id,
          birthdate: moment(doc.data().birthdate.toDate()).format('DD/MM/YYYY'),
          joined_at: moment(doc.data().birthdate.toDate()).format('DD/MM/YYYY'),
        })
      })
    }).catch((error) => {
      console.log("Error getting cached document:", error)
      return null
    })
    return data
  },
  show(id) {
    return clients.doc(id).get()
  },
  create(params) {
    return clients.where("contact_number", "==", params.contact_number).get().then((querySnapshot) => {
      if (!querySnapshot.empty) {
        querySnapshot.forEach((doc) => {
          if (doc.data().name !== params.name) {
            throw {
              response: {
                data: doc.data(),
              }
            }
          }
        })
      } else {
        return clients.add(params)
      }
    })
  },
  update(params) {
    return clients.doc(params.id).set(params)
  },
  delete(id) {
    return clients.doc(id).delete()
  }
}